import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
export class CBcSnackbar {
    constructor(option) {
        this.visible = false;
        this.text = '';
        this.x = '';
        this.y = 'top';
        this.timeout = 3000;
        this.color = 'info';
        this.vertical = true;
        this.positiveButtonText = '';
        if (/string/i.test(typeof option)) {
            this.text = option; // 类型断言
        }
        else {
            const op = option;
            const text = op && op['text'] || '';
            this.text = text;
            this.color = op && op['color'] || 'info';
            this.timeout = Number(op && (op['timeout'] || op['duration']) || '3000');
            this.x = op && op['x'] || '';
            this.y = op && op['y'] || 'top';
            this.vertical = /undefined|null/i.test(op && op['vertical']) ? true : (op && op['vertical']);
        }
    }
    show() {
        this.visible = true;
    }
    close() {
        this.visible = false;
    }
    open(option) {
        const that = this;
        try {
            const op = option;
            const text = typeof op === 'object' ? op['text'] : op;
            if (!text)
                return console.log('text is argument is required.');
            this.text = text;
            this.color = op && op['color'] || 'info';
            this.timeout = Number(op && (op['timeout'] || op['duration']) || '3000');
            this.x = op && op['x'] || '';
            this.y = op && op['y'] || 'top';
            this.vertical = /undefined|null/i.test(op && op['vertical']) ? true : (op && op['vertical']);
            that.show();
        }
        catch (e) {
            console.log('error of open snackbar:', e);
        }
    }
    info(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'grey',
        });
    }
    success(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'success',
        });
    }
    error(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'error',
        });
    }
    warn(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'orange lighten-1',
        });
    }
}
let BcSnackbar = class BcSnackbar extends Vue {
};
__decorate([
    Prop()
], BcSnackbar.prototype, "instance", void 0);
BcSnackbar = __decorate([
    Component({
        name: 'BcSnackbar',
    })
], BcSnackbar);
export default BcSnackbar;
;
